import React from "react";
import MarketingNavbar from "./MarketingNavbar";
import MarketingFooter from "./MarketingFooter";

export default function MarketingLayout({ children }: { children: React.ReactNode }) {
    return (
        <>
            <MarketingNavbar />
            <main>{children}</main>
            <MarketingFooter />
        </>
    );
}
